import React from 'react';
import CustomPortal from "../../CustomPortal";
import VerifyInvitationCode from '../../registration-component/VerifyInvitationCode';

const InvitationForm = () => {
  return (
    <CustomPortal
        header="Sign up with invite code"
        Component={VerifyInvitationCode}
    />
  );
}

export default InvitationForm;
